import env from '../env/'
let defaultConfig = {
    fusionChartKey: env.FUSION_CHART_KEY,
    
    stackedChart: {
        "type": "stackedbar2d",
        "id": 'edw-stacked-chart',
        "width": '100%',
        "height": '100%',
        "dataFormat": 'json',
        "dataSource": {
            "chart": {
                "theme": "fusion",
                "caption": "",
                "subCaption": "",
                "xAxisname": "",
                "yAxisName": "",
                "showSum": "1",
                "theme": "fusion",
                "showPlotBorder": "1",
                "showToolTip": "0",
                "plotSpacePercent": "20",
                "showHoverEffect": "1",
                "plotHoverEffect": "1",
                "rotateXAxisName": "0",
                //"showYAxisLine": "1",
                "trendlineThickness": "5",
                "plotBorderThickness": "2",
                "showLegend": "0",
                "plotBorderColor": "#666666"
            },
            "categories": [],
            "dataset": []
        }
    },
    colorCodes: {
        // "good": "#d9fae4",
        // "bad": "#fad9de",
        // "avg": "#fae3cc",

        "bad": "#db0020",
        "good": "#009e42",
        "avg": "#e27a0e",

        "badHover": "#fad9de",
        "goodHover": "#d9fae4",
        "avgHover": "#fae3cc",
        "borderColor": "#8E8F9C"
    },
    topicsData: [

        {
            topicId: '1',
            topicDescription: "Multiplicative relationships",
            topicOrderByPerfomance: '3',
            lowMarksCount: 2,
            avgMarksCount: 2,
            goodMarksCount: 1,
            questions: [
                { questionId: "Q1", mark: "low", name: "Question 1 ", descrition: "question decsription" }
                ,
                { questionId: "Q2", mark: "avg", name: "Question 2 ", descrition: "question decsription" }
                ,
                { questionId: "Q1", mark: "low", name: "Question 3 ", descrition: "question decsription" }
                ,
                { questionId: "Q2", mark: "avg", name: "Question 4 ", descrition: "question decsription" },

                { questionId: "Q2", mark: "good", name: "Question 5 ", descrition: "question decsription" }


            ]
        },
        {
            topicId: '2',
            topicDescription: "Direct and indirect proportion",
            topicOrderByPerfomance: 2,
            questions: [
                { questionId: "Q1", mark: "low", descrition: "question decsription" }
                ,

                { questionId: "Q2", mark: "avg", descrition: "question decsription" }
            ]
        },
        {
            topicId: '3',
            topicDescription: "Calcuations",
            topicOrderByPerfomance: 1,
            questions: [
                { questionId: "Q1", mark: "good", descrition: "question decsription" }
                ,

                { questionId: "Q2", mark: "good", descrition: "question decsription" }
            ]
        }

    ],
    barChart: {
        type: "bar2d",
        width: "100%",
        height: "100%",
        dataFormat: "json",
        dataSource: {
            // Chart Configuration
            chart: {
                caption: "",
                subCaption: "",
                xAxisName: "",
                rotateXAxisName: "0",
                yAxisName: "",
                theme: "fusion",
                palettecolors: "a1e4df",
                showPlotBorder: "1",
                plotBorderColor: '#00a396',
                plotBorderThickness: "2",
                plotFillHoverColor: "#00a396",
                plotSpacePercent: 48,
                showToolTip:0

            },

            data: []
        }
    },
 
    topicChart: {
        type: "bar2d",
        width: "100%",
        height: "100%",
        dataFormat: "json",
        dataSource: {
            // Chart Configuration
            chart: {
                caption: "",
                subCaption: "",
                xAxisName: "",
                yAxisName: "",
                theme: "fusion",
                showPlotBorder: "1",
                plotBorderColor: '#01010f',
                plotBorderThickness: "2",
                showlegend: "1",

            },

            data: []
        }
    }


};

export default defaultConfig;

